import React, { useRef } from 'react';
import { ProfileAvatarProps } from '../../../types';
import Icon from '../../atoms/Icon';
import './ProfileAvatar.css';

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  photoURL,
  displayName,
  size = 'medium',
  onUpload,
  className = ''
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const avatarClasses = `profile-avatar avatar-${size} ${className}`.trim();
  
  // Get initials from display name
  const getInitials = () => {
    if (!displayName) return '?';
    
    const names = displayName.split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    
    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
  };
  
  const handleClick = () => {
    if (onUpload && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onUpload && e.target.files && e.target.files[0]) {
      onUpload(e.target.files[0]);
    }
  };
  
  return (
    <div 
      className={avatarClasses}
      onClick={onUpload ? handleClick : undefined}
      style={{ cursor: onUpload ? 'pointer' : 'default' }}
    >
      {photoURL ? (
        <img src={photoURL} alt={displayName} className="avatar-image" />
      ) : (
        <div className="avatar-initials">{getInitials()}</div>
      )}
      
      {onUpload && (
        <>
          <div className="avatar-overlay">
            <Icon type="upload" size="small" />
          </div>
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            accept="image/*"
            className="avatar-input"
          />
        </>
      )}
    </div>
  );
};

export default ProfileAvatar;
